import { jsx as _jsx } from "react/jsx-runtime";
import { x } from '@xstyled/styled-components';
export var Box = function Box(_ref) {
  var children = _ref.children,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#f9f9f9' : _ref$backgroundColor;
  return /*#__PURE__*/_jsx(x.div, {
    p: "20px",
    background: backgroundColor,
    children: children
  });
};